import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  addGateAccessData,
  deleteGateAccessData,
  fetchGateAccessList,
  generateGateListData,
  updateGateAccessData,
} from "../../apis/gateAccess";

export const fetchGateAccessListData = createAsyncThunk(
  "gateAccess/fetchList",
  async (_, { rejectWithValue }) => {
    try {
      return await fetchGateAccessList();
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
  {
    condition: (_, { getState }) => {
      const state = getState() as any;
      return !state.gateAccess.isDataFetched;
    },
  }
);

export const addNewGateAccessData = createAsyncThunk(
  "gateAccess/add",
  async ({ data }: { data: { [key: string]: any } }, { rejectWithValue }) => {
    try {
      return await addGateAccessData(data);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  }
);

export const updateGateAccessEntry = createAsyncThunk(
  "gateAccess/update",
  async (
    { id, data }: { id: string; data: { [key: string]: any } },
    { rejectWithValue }
  ) => {
    try {
      return await updateGateAccessData(id, data);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  }
);

export const deleteGateAccessEntry = createAsyncThunk(
  "gateAccess/delete",
  async ({ id }: { id: string }, { rejectWithValue }) => {
    try {
      return await deleteGateAccessData(id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const generateGateList = createAsyncThunk(
  "gateAccess/generateGateList",
  async ({ company, companyId, template }: { company: string; companyId?: string; template?: string }, { rejectWithValue }) => {
    try {
      return await generateGateListData(company, companyId, template);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  }
);
